import { useEffect } from 'react';

/**
 * Per-page SEO: updates <title>, meta description, canonical URL, OG tags.
 * Call once at the top of each page component.
 *
 * Usage:
 *   useSEO({
 *     title: 'Réserver une table — NotaBene Sympho',
 *     description: 'Réservez votre table...',
 *     canonical: '/reservation',
 *   });
 */
const SITE_URL = 'https://notabenesympho.be';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const setMeta = (selector, content, attrName = 'content') => {
  if (!content) return;
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attrName, content);
};

const useSEO = ({ title, description, canonical, ogImage } = {}) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', title);
      setMeta('meta[name="twitter:title"]', title);
    }
    if (canonical) {
      const fullUrl = canonical.startsWith('http') ? canonical : `${SITE_URL}${canonical}`;
      setMeta('link[rel="canonical"]', fullUrl, 'href');
      setMeta('meta[property="og:url"]', fullUrl);
    }
    const img = ogImage || DEFAULT_OG_IMAGE;
    setMeta('meta[property="og:image"]', img);
    setMeta('meta[name="twitter:image"]', img);
  }, [title, description, canonical, ogImage]);
};

export default useSEO;
